export const FHIR_MAPPINGS = {
  "Envelope.SenderId": {
    fhirPath: null,
    source: "clientConfig",
    notes: "Configured per client in Client.json envelope settings.",
  },
  "Envelope.ReceiverId": {
    fhirPath: null,
    source: "clientConfig",
    notes: "Configured per client in Client.json envelope settings.",
  },
  "Envelope.UsageIndicator": {
    fhirPath: null,
    source: "clientConfig",
    notes: "T = Test, P = Production.",
  },
  ControlNumber: {
    fhirPath: null,
    source: "computed",
    transform: "deriveControlNumber",
    notes: "Derived from TrackingNumber at render time.",
  },
  TrackingNumber: {
    fhirPath: "Bundle.entry.resource.where(resourceType='Claim').first().id",
    transform: "deriveTrackingNumber",
    notes: "Reuses Claim.id verbatim; mints PAS-{guid} when absent.",
  },
  GeneratedAt: {
    fhirPath: null,
    transform: "utcNow",
    notes: "Set at map time; not sourced from FHIR.",
  },
  BhtPurposeCode: {
    fhirPath: "Claim.status",
    transform: "mapBhtPurpose",
    notes: "Claim.status cancelled → Cancellation; else Request.",
  },
  BhtTransactionTypeCode: {
    fhirPath: "Claim.supportingInfo[category=requestType]",
    transform: "extractBhtTransactionType",
    notes: "From supportingInfo requestType category.",
  },
  "Payer.Name": {
    fhirPath: "Coverage.payor.display",
    fallbackPath: "Organization.name",
    notes: "Payer display name from Coverage or Organization.",
  },
  "Payer.PayerId": {
    fhirPath: "Coverage.class[plan].value",
    fallbackPath: "Coverage.identifier.value",
    notes: "Plan ID or coverage identifier.",
  },
  "Payer.IdentifierCode": {
    fhirPath: "Organization.identifier.system",
    transform: "resolvePayerIdentifier",
    notes: "Maps identifier.system → PI/XX/24/46/XV.",
  },
  "Requester.LastName": {
    fhirPath: "Claim.provider → Practitioner.name.family",
    fallbackPath: "Claim.provider → Organization.name",
    transform: "buildRequester",
    notes: "NM102=1 for Practitioner, NM102=2 for Organization.",
  },
  "Requester.OrganizationName": {
    fhirPath: "Claim.provider → Organization.name",
    transform: "buildRequester",
  },
  "Requester.FirstName": {
    fhirPath: "Claim.provider → Practitioner.name.given",
    transform: "buildRequester",
  },
  "Requester.Npi": {
    fhirPath: "Claim.provider → Practitioner.identifier[NPI]",
    transform: "buildRequester",
  },
  "Requester.Phone": {
    fhirPath: "Claim.provider → Practitioner.telecom[phone]",
    transform: "buildRequester",
  },
  "Requester.EntityTypeQualifier": {
    fhirPath: "Claim.provider resourceType",
    transform: "buildRequester",
    notes: "1 = Person, 2 = Organization.",
  },
  "Subscriber.LastName": {
    fhirPath: "Coverage.subscriber → Patient.name.family",
    transform: "buildSubscriber",
  },
  "Subscriber.FirstName": {
    fhirPath: "Coverage.subscriber → Patient.name.given",
    transform: "buildSubscriber",
  },
  "Subscriber.MemberId": {
    fhirPath: "Coverage.subscriberId",
    transform: "buildSubscriber",
  },
  "Subscriber.BirthDate": {
    fhirPath: "Coverage.subscriber → Patient.birthDate",
    transform: "buildSubscriber",
  },
  "Subscriber.Gender": {
    fhirPath: "Coverage.subscriber → Patient.gender",
    transform: "buildSubscriber",
  },
  "Subscriber.EntityId": {
    fhirPath: null,
    defaultValue: "IL",
    notes: "Fixed entity identifier for insured subscriber.",
  },
  "Subscriber.EntityType": {
    fhirPath: null,
    defaultValue: "1",
    notes: "1 = Person.",
  },
  "Subscriber.IdQualifier": {
    fhirPath: null,
    defaultValue: "MI",
    notes: "Member identification qualifier.",
  },
  "Subscriber.DateFormat": {
    fhirPath: null,
    defaultValue: "D8",
    notes: "CCYYMMDD date format.",
  },
  PrimaryDiagnosis: {
    fhirPath: "Claim.diagnosis.coding.code",
    notes: "Primary ICD-10 diagnosis on the event.",
  },
  Diagnoses: {
    fhirPath: "Claim.diagnosis.coding.code",
    notes: "Diagnosis composite on the patient event.",
  },
  Services: {
    fhirPath: "Claim.item.servicedPeriod",
    transform: "serviceDateRange",
    notes: "Service date range for the event.",
  },
  AdmissionType: {
    fhirPath: "Claim.supportingInfo[category=admissionType]",
    defaultValue: "1",
  },
  LevelOfServiceCode: {
    fhirPath: "Claim.supportingInfo[category=levelOfService].code.coding.code",
    notes: "Event UM06: supportingInfo levelOfService only (not item extension).",
  },
  HasAttachments: {
    fhirPath: "Claim.supportingInfo[category=attachment]",
    transform: "boolToYN",
    defaultValue: "N",
  },
  OriginalAuthorizationNumber: {
    fhirPath: "Claim.insurance.preAuthRef",
    notes:
      "Prior authorization number from Claim.insurance[].preAuthRef → REF*BB (PasBundleMapper.ExtractOriginalAuthorizationNumber).",
  },
  AdminReferenceNumber: {
    fhirPath:
      "Claim.extension[administrationReferenceNumber] or Claim.supportingInfo[category=administrationReferenceNumber]",
    notes:
      "Administrative reference → REF*9F (PasBundleMapper.ExtractAdminReferenceNumber).",
  },
  "Service.OriginalAuthorizationNumber": {
    fhirPath:
      "Claim.item.extension[authorizationNumber]",
    notes:
      "Service-line auth number (PAS extension-authorizationNumber) → REF*BB in 2000F.",
  },
  "Service.AdminReferenceNumber": {
    fhirPath:
      "Claim.item.extension[administrationReferenceNumber]",
    notes:
      "Service-line admin ref (PAS extension-administrationReferenceNumber) → REF*9F in 2000F.",
  },
  LengthOfStayDays: {
    fhirPath:
      "Claim.supportingInfo[lengthOfStay|additionalLengthOfStay].valueQuantity.value",
    transform: "extractLengthOfStayDays",
    notes:
      "HSD*DY from supportingInfo lengthOfStay — NOT Claim.item.quantity (that is service-line SV quantity).",
  },
  "EventProvider.Phone": {
    fhirPath: "Claim.careTeam.telecom[phone]",
    notes: "Event provider contact phone.",
  },
  "ServiceProvider.Phone": {
    fhirPath: "Claim.careTeam.telecom[phone]",
    notes: "Service provider contact phone.",
  },
  "Requester.MiddleName": {
    fhirPath: "Claim.provider → Practitioner.name.given",
    transform: "buildRequester",
  },
  "Requester.Taxonomy": {
    fhirPath: "Claim.provider → Practitioner.qualification.code",
    transform: "buildRequester",
  },
  "Requester.Address.Line1": {
    fhirPath: "Claim.provider → Practitioner.address.line",
    transform: "buildRequester",
  },
  "Subscriber.MiddleName": {
    fhirPath: "Coverage.subscriber → Patient.name.given",
    transform: "buildSubscriber",
  },
  "Dependent.BirthDate": {
    fhirPath: "Patient.birthDate",
    transform: "buildDependent",
  },
  "Dependent.Gender": {
    fhirPath: "Patient.gender",
    transform: "buildDependent",
  },
  "Dependent.LastName": {
    fhirPath: "Patient.name.family",
    transform: "buildDependent",
  },
  "Dependent.FirstName": {
    fhirPath: "Patient.name.given",
    transform: "buildDependent",
  },
  "Service.ServiceTraceNumber": {
    fhirPath: "Claim.item.extension.traceNumber",
    notes: "Service line trace number.",
  },
  CertificationAction: {
    fhirPath: "Claim.extension.certificationAction",
    defaultValue: "I",
    notes: "Initial, extension, cancel, etc.",
  },
  CertificationType: {
    fhirPath:
      "Claim.item.where(productOrService absent).category.coding[CertificationTypeCS].code",
    defaultValue: "HS",
    notes:
      "Event UM01: non-service item CertificationTypeCS only; service-line category → 2000F. Default HS.",
  },
  ServiceTypeCode: {
    fhirPath: "Claim.item.category.coding.code",
    transform: "lookup",
    lookupTable: "CodeSets.serviceTypeByRequestCategory",
  },
  PlaceOfService: {
    fhirPath: "Claim.facility → Location.type[CMS POS]",
    transform: "extractPlaceOfService",
    defaultValue: "11",
    notes: "Event UM04: facility Location CMS POS only. Not Claim.item.location.",
  },
  Messages: {
    fhirPath: "Claim.supportingInfo[category=info].valueString",
    notes: "Free-form narrative from supportingInfo.",
  },
  "Service.ProcedureCode": {
    fhirPath: "Claim.item.productOrService.coding.code",
    notes: "HCPCS/CPT procedure code on service line.",
  },
  "Service.ChargeAmount": {
    fhirPath: "Claim.item.unitPrice",
    notes: "Line item charge amount.",
  },
  "Service.Quantity": {
    fhirPath: "Claim.item.quantity.value",
    notes: "Service unit count.",
  },
  "Service.ServiceDate": {
    fhirPath: "Claim.item.servicedPeriod.start",
    notes: "Date of service for the event.",
  },

  // ── Address (Requester / Subscriber / Dependent / Facility) ──
  "Requester.Address.Line2": {
    fhirPath: "Claim.provider → Practitioner.address.line[1]",
    fallbackPath: "Claim.provider → Organization.address.line[1]",
    transform: "buildRequester",
  },
  "Requester.Address.City": {
    fhirPath: "Claim.provider → Practitioner.address.city",
    fallbackPath: "Claim.provider → Organization.address.city",
    transform: "buildRequester",
  },
  "Requester.Address.State": {
    fhirPath: "Claim.provider → Practitioner.address.state",
    fallbackPath: "Claim.provider → Organization.address.state",
    transform: "buildRequester",
  },
  "Requester.Address.PostalCode": {
    fhirPath: "Claim.provider → Practitioner.address.postalCode",
    fallbackPath: "Claim.provider → Organization.address.postalCode",
    transform: "buildRequester",
  },
  "Requester.IdentifierCode": {
    fhirPath: "Claim.provider → Practitioner.identifier.system",
    fallbackPath: "Claim.provider → Organization.identifier.system",
    transform: "resolvePayerIdentifier",
    notes: "Maps identifier.system → XX/PI/etc.",
  },
  "Subscriber.Address.Line1": {
    fhirPath: "Coverage.subscriber → Patient.address.line[0]",
    transform: "buildSubscriber",
  },
  "Subscriber.Address.Line2": {
    fhirPath: "Coverage.subscriber → Patient.address.line[1]",
    transform: "buildSubscriber",
  },
  "Subscriber.Address.City": {
    fhirPath: "Coverage.subscriber → Patient.address.city",
    transform: "buildSubscriber",
  },
  "Subscriber.Address.State": {
    fhirPath: "Coverage.subscriber → Patient.address.state",
    transform: "buildSubscriber",
  },
  "Subscriber.Address.PostalCode": {
    fhirPath: "Coverage.subscriber → Patient.address.postalCode",
    transform: "buildSubscriber",
  },
  "Subscriber.IndividualRelationshipCode": {
    fhirPath: "Coverage.relationship",
    notes: "Y = self / subscriber indicator (INS01).",
  },
  "Subscriber.RelationshipCode": {
    fhirPath: "Coverage.relationship.coding.code",
    notes: "X12 individual relationship code (INS02), e.g. 18 = self.",
  },
  "Dependent.Address.Line1": {
    fhirPath: "Patient.address.line[0]",
    transform: "buildDependent",
  },
  "Dependent.Address.Line2": {
    fhirPath: "Patient.address.line[1]",
    transform: "buildDependent",
  },
  "Dependent.Address.City": {
    fhirPath: "Patient.address.city",
    transform: "buildDependent",
  },
  "Dependent.Address.State": {
    fhirPath: "Patient.address.state",
    transform: "buildDependent",
  },
  "Dependent.Address.PostalCode": {
    fhirPath: "Patient.address.postalCode",
    transform: "buildDependent",
  },
  "Dependent.MiddleName": {
    fhirPath: "Patient.name.given[1]",
    transform: "buildDependent",
  },
  "Dependent.IndividualRelationshipCode": {
    fhirPath: "Coverage.relationship",
    notes: "N = dependent (not self).",
  },
  "Dependent.RelationshipCode": {
    fhirPath: "Coverage.relationship.coding.code",
    notes: "X12 relationship for dependent (e.g. 19 = child).",
  },
  "FacilityAddress.Line1": {
    fhirPath: "Claim.facility → Location.address.line[0]",
    transform: "resolveFacilityAddress",
  },
  "FacilityAddress.Line2": {
    fhirPath: "Claim.facility → Location.address.line[1]",
    transform: "resolveFacilityAddress",
  },
  "FacilityAddress.City": {
    fhirPath: "Claim.facility → Location.address.city",
    transform: "resolveFacilityAddress",
  },
  "FacilityAddress.State": {
    fhirPath: "Claim.facility → Location.address.state",
    transform: "resolveFacilityAddress",
  },
  "FacilityAddress.PostalCode": {
    fhirPath: "Claim.facility → Location.address.postalCode",
    transform: "resolveFacilityAddress",
  },
  FacilityName: {
    fhirPath: "Claim.facility → Location.name",
    transform: "resolveFacilityField",
  },
  FacilityIdentifier: {
    fhirPath: "Claim.facility → Location.identifier.value",
    transform: "resolveFacilityField",
  },
  FacilityIdentifierCode: {
    fhirPath: "Claim.facility → Location.identifier.system",
    transform: "resolveFacilityIdentifierCode",
  },

  // ── Supplemental REF ids ──
  "SupplementalId.Qualifier": {
    fhirPath: "Identifier.system",
    transform: "mapIdentifierToRefQualifier",
    notes: "Non-primary identifiers → REF01 (XX/24/46/PI).",
  },
  "SupplementalId.Value": {
    fhirPath: "Identifier.value",
    notes: "Non-primary identifier value → REF02.",
  },

  // ── Event provider (non–claim-scope careTeam) ──
  "EventProvider.EntityIdentifierCode": {
    fhirPath: "Claim.careTeam.role.coding.code",
    notes: "Maps claimcareteamrole → NM101 (FA/SJ/etc.).",
  },
  "EventProvider.EntityTypeQualifier": {
    fhirPath: "Claim.careTeam → provider resourceType",
    notes: "1 = Person, 2 = Organization.",
  },
  "EventProvider.LastName": {
    fhirPath: "Claim.careTeam → Practitioner.name.family",
    fallbackPath: "Claim.careTeam → Organization.name",
  },
  "EventProvider.FirstName": {
    fhirPath: "Claim.careTeam → Practitioner.name.given[0]",
  },
  "EventProvider.MiddleName": {
    fhirPath: "Claim.careTeam → Practitioner.name.given[1]",
  },
  "EventProvider.Identifier": {
    fhirPath: "Claim.careTeam → Practitioner.identifier[NPI]",
    fallbackPath: "Claim.careTeam → Organization.identifier",
  },
  "EventProvider.IdentifierCode": {
    fhirPath: "Claim.careTeam → Practitioner.identifier.system",
  },
  "EventProvider.Taxonomy": {
    fhirPath: "Claim.careTeam.qualification.coding.code",
  },
  "EventProvider.Address.Line1": {
    fhirPath: "Claim.careTeam → Practitioner.address.line[0]",
    fallbackPath: "Claim.careTeam → Organization.address.line[0]",
  },
  "EventProvider.Address.Line2": {
    fhirPath: "Claim.careTeam → Practitioner.address.line[1]",
    fallbackPath: "Claim.careTeam → Organization.address.line[1]",
  },
  "EventProvider.Address.City": {
    fhirPath: "Claim.careTeam → Practitioner.address.city",
    fallbackPath: "Claim.careTeam → Organization.address.city",
  },
  "EventProvider.Address.State": {
    fhirPath: "Claim.careTeam → Practitioner.address.state",
    fallbackPath: "Claim.careTeam → Organization.address.state",
  },
  "EventProvider.Address.PostalCode": {
    fhirPath: "Claim.careTeam → Practitioner.address.postalCode",
    fallbackPath: "Claim.careTeam → Organization.address.postalCode",
  },

  // ── Service provider (2000F) ──
  "ServiceProvider.Role": {
    fhirPath: "Claim.careTeam.role.coding.code",
    notes: "NM101 role from careTeam / item.performer.",
  },
  "ServiceProvider.EntityTypeQualifier": {
    fhirPath: "Claim.careTeam → provider resourceType",
  },
  "ServiceProvider.LastName": {
    fhirPath: "Claim.careTeam → Practitioner.name.family",
    fallbackPath: "Claim.careTeam → Organization.name",
  },
  "ServiceProvider.FirstName": {
    fhirPath: "Claim.careTeam → Practitioner.name.given[0]",
  },
  "ServiceProvider.Npi": {
    fhirPath: "Claim.careTeam → Practitioner.identifier[NPI]",
  },
  "ServiceProvider.IdentifierCode": {
    fhirPath: "Claim.careTeam → Practitioner.identifier.system",
  },
  "ServiceProvider.Taxonomy": {
    fhirPath: "Claim.careTeam.qualification.coding.code",
  },
  "ServiceProvider.Address.Line1": {
    fhirPath: "Claim.careTeam → Practitioner.address.line[0]",
  },
  "ServiceProvider.Address.Line2": {
    fhirPath: "Claim.careTeam → Practitioner.address.line[1]",
  },
  "ServiceProvider.Address.City": {
    fhirPath: "Claim.careTeam → Practitioner.address.city",
  },
  "ServiceProvider.Address.State": {
    fhirPath: "Claim.careTeam → Practitioner.address.state",
  },
  "ServiceProvider.Address.PostalCode": {
    fhirPath: "Claim.careTeam → Practitioner.address.postalCode",
  },

  // ── Event dates / DTP ──
  "EventDates.AccidentDate": {
    fhirPath: "Claim.accident.date",
  },
  "EventDates.OnsetDate": {
    fhirPath: "Claim.supportingInfo[category=onsetDate]",
  },
  "EventDates.AdmissionDate": {
    fhirPath: "Claim.supportingInfo[category=admissionDate]",
  },
  "EventDates.DischargeDate": {
    fhirPath: "Claim.supportingInfo[category=dischargeDate]",
  },
  "EventDates.LastMenstrualPeriodDate": {
    fhirPath: "Claim.supportingInfo[category=lastMenstrualPeriod]",
  },
  "EventDates.EstimatedDateOfBirth": {
    fhirPath: "Claim.supportingInfo[category=estimatedDateOfBirth]",
  },
  EventDtpQualifier: {
    fhirPath: null,
    source: "computed",
    transform: "eventDtpQualifier",
    notes: "DTP01 derived from which event date is populated.",
  },
  EventDtpFormat: {
    fhirPath: null,
    defaultValue: "D8",
    notes: "Static DTP02 date format.",
  },

  // ── Frequency / certification period ──
  "Frequency.QuantityQualifier": {
    fhirPath:
      "Claim.supportingInfo[category=frequency].extension.quantityQualifier",
  },
  "Frequency.Quantity": {
    fhirPath: "Claim.supportingInfo[category=frequency].extension.quantity",
  },
  "Frequency.PeriodUnit": {
    fhirPath: "Claim.supportingInfo[category=frequency].extension.periodUnit",
  },
  "Frequency.DurationQualifier": {
    fhirPath: "Claim.supportingInfo[category=frequency].extension.modulus",
  },
  "Frequency.Duration": {
    fhirPath: "Claim.supportingInfo[category=frequency].extension.occurrences",
  },
  "Service.Frequency.QuantityQualifier": {
    fhirPath:
      "Claim.item → supportingInfo[category=frequency].extension.quantityQualifier",
  },
  "Service.Frequency.Quantity": {
    fhirPath:
      "Claim.item → supportingInfo[category=frequency].extension.quantity",
  },
  "Service.Frequency.PeriodUnit": {
    fhirPath:
      "Claim.item → supportingInfo[category=frequency].extension.periodUnit",
  },
  "Service.Frequency.DurationQualifier": {
    fhirPath:
      "Claim.item → supportingInfo[category=frequency].extension.modulus",
  },
  "Service.Frequency.Duration": {
    fhirPath:
      "Claim.item → supportingInfo[category=frequency].extension.occurrences",
  },
  CertificationPeriod: {
    fhirPath: "Claim.supportingInfo[category=certificationperiod].timing",
  },
  "CertificationPeriod.CertificationStartDate": {
    fhirPath:
      "Claim.supportingInfo[category=certificationperiod].timing.Period.start",
  },

  // ── Ambulance / transport location ──
  "AmbulanceTransport.TransportCode": {
    fhirPath:
      "Claim.supportingInfo[category=ambulanceTransport].extension.transportCode",
  },
  "AmbulanceTransport.DistanceQualifier": {
    fhirPath:
      "Claim.supportingInfo[category=ambulanceTransport].extension.distanceQualifier",
  },
  "AmbulanceTransport.TransportReason": {
    fhirPath:
      "Claim.supportingInfo[category=ambulanceTransport].extension.transportReason",
  },
  "AmbulanceTransport.PatientLocationCode": {
    fhirPath:
      "Claim.supportingInfo[category=ambulanceTransport].extension.patientLocationCode",
  },
  "AmbulanceTransport.Description": {
    fhirPath:
      "Claim.supportingInfo[category=ambulanceTransport].extension.description",
  },
  "TransportLocation.EntityCode": {
    fhirPath:
      "Claim.supportingInfo[category=ambulanceTransport].extension.tripLocation.entityCode",
  },
  "TransportLocation.Name": {
    fhirPath:
      "Claim.supportingInfo[ambulanceTransport].tripLocation → Location.name",
  },
  "TransportLocation.Address1": {
    fhirPath: "tripLocation → Location.address.line[0]",
  },
  "TransportLocation.Address2": {
    fhirPath: "tripLocation → Location.address.line[1]",
  },
  "TransportLocation.City": {
    fhirPath: "tripLocation → Location.address.city",
  },
  "TransportLocation.State": {
    fhirPath: "tripLocation → Location.address.state",
  },
  "TransportLocation.PostalCode": {
    fhirPath: "tripLocation → Location.address.postalCode",
  },

  // ── CRC / chiro / oxygen / other UMO / MSG ──
  "CertificationIndicator.Category": {
    fhirPath: "Claim.extension[conditionCode].category",
  },
  "CertificationIndicator.Applies": {
    fhirPath: "Claim.extension[conditionCode].indicator",
  },
  "Chiropractic.PatientConditionCode": {
    fhirPath: "Claim.supportingInfo[category=chiropracticCertification]",
  },
  "Chiropractic.XRayAvailability": {
    fhirPath: "Claim.supportingInfo[category=chiropracticCertification]",
  },
  "OxygenTherapy.EquipmentTypeCode": {
    fhirPath: "Claim.supportingInfo[category=oxygenTherapyCertification]",
  },
  "OxygenTherapy.Quantity": {
    fhirPath: "Claim.supportingInfo[category=oxygenTherapyCertification]",
  },
  "OtherUmo.Name": {
    fhirPath: "Claim.supportingInfo[category=otherUmoDenial]",
  },
  "OtherUmo.DenialReasonCode": {
    fhirPath: "Claim.supportingInfo[category=otherUmoDenial]",
  },
  "OtherUmo.DenialDate": {
    fhirPath: "Claim.supportingInfo[category=otherUmoDenial].timing",
  },
  CurrentMessage: {
    fhirPath:
      "Claim.supportingInfo[category=additionalInformation|message|note].valueString",
  },
  CurrentServiceMessage: {
    fhirPath: "Claim.item → supportingInfo[category=message].valueString",
  },

  // ── Service line / money / tooth / system ──
  Service: {
    fhirPath: "Claim.item",
    notes: "Service line composite (dates / procedure context).",
  },
  "Service.CertificationType": {
    fhirPath: "Claim.item.category.coding[CertificationTypeCS].code",
  },
  "Service.Description": {
    fhirPath: "Claim.item.productOrService.text",
    fallbackPath: "Claim.item.productOrService.coding.display",
  },
  "Service.PlaceOfService": {
    fhirPath: "Claim.item.locationCodeableConcept.coding.code",
  },
  "Service.QuantityRequested": {
    fhirPath: "Claim.item.quantity.value",
  },
  "Service.QuantityType": {
    fhirPath: "Claim.item.quantity",
    transform: "mapQuantityType",
    notes: "Maps FHIR quantity unit → UN/etc.",
  },
  "Service.RevenueCode": {
    fhirPath: "Claim.item.revenue.coding.code",
    notes: "Institutional claims only.",
  },
  "Service.MonetaryAmount.net": {
    fhirPath: "Claim.item.net.value",
  },
  "Service.MonetaryAmount.quantity": {
    fhirPath: "Claim.item.quantity.value",
  },
  "Service.MonetaryAmount.unitPrice": {
    fhirPath: "Claim.item.unitPrice.value",
  },
  ServiceDtpFormat: {
    fhirPath: null,
    defaultValue: "D8",
    notes: "Static DTP02 for service dates.",
  },
  CurrentToothCode: {
    fhirPath: "Claim.item.bodySite",
    notes: "Dental tooth code on service line.",
  },
  SegmentCount: {
    fhirPath: null,
    source: "computed",
    transform: "segmentCount",
    notes: "SE01 — computed at emit time; not from FHIR.",
  },
  "Envelope.TraceAssigningEntityId": {
    fhirPath: null,
    source: "clientConfig",
    notes: "TRN03 originating company id from client config.",
  },
};

export const SEGMENT_FRIENDLY_NAMES = {
  ISA: "Interchange Header",
  GS: "Functional Group Header",
  ST: "Transaction Set Header",
  BHT: "Beginning of Transaction",
  HL_2000A: "Hierarchical Level — Payer",
  NM1_PR: "Payer Name",
  PER_IC: "Payer Contact",
  HL_2000B: "Hierarchical Level — Provider",
  NM1_1P: "Requester Name",
  PER_1P: "Requester Contact",
  HL_2000C: "Hierarchical Level — Subscriber",
  NM1_IL: "Subscriber Name",
  DMG_IL: "Subscriber Demographics",
  HL_2000E: "Patient Event Level",
  TRN_EVENT: "Patient Event Tracking Number",
  UM_EVENT: "Health Care Services Review Information",
  REF_BB: "Previous Review Authorization Number",
  REF_ADMIN: "Previous Review Administrative Reference Number",
  DTP_ACCIDENT: "Accident Date",
  DTP_LMP: "Last Menstrual Period Date",
  DTP_EDB: "Estimated Date of Birth",
  DTP_ONSET: "Onset of Current Symptoms or Illness Date",
  DTP_EVENT: "Event Date",
  DTP_ADMISSION: "Admission Date",
  DTP_DISCHARGE: "Discharge Date",
  DTP_472: "Service Date",
  HI_EVENT: "Patient Diagnosis",
  HSD_LOS: "Health Care Services Delivery — Length of Stay",
  HSD_FREQ: "Health Care Services Delivery — Frequency",
  CRC_AMBULANCE: "Ambulance Certification Information",
  CRC_CHIRO: "Chiropractic Certification Information",
  CRC_DME: "Durable Medical Equipment Certification",
  CRC_OXYGEN: "Oxygen Therapy Certification Information",
  CL1_EVENT: "Institutional Claim Code",
  CR1_EVENT: "Ambulance Transport Information",
  CR2_EVENT: "Spinal Manipulation Service Information",
  CR5_EVENT: "Home Oxygen Therapy Information",
  CR6_EVENT: "Home Health Care Information",
  PWK_EVENT: "Additional Patient Information",
  MSG_EVENT: "Message Text",
  NM1_FA: "Patient Event Provider Name — Facility",
  N3_FA: "Facility Address",
  N4_FA: "Facility City/State/ZIP",
  NM1_EP: "Patient Event Provider Name",
  REF_EP: "Patient Event Provider Supplemental Information",
  HL_2000F: "Service Level",
  SV1: "Professional Service",
  SE: "Transaction Set Trailer",
  GE: "Functional Group Trailer",
  IEA: "Interchange Trailer",
};

export const ELEMENT_BINDINGS = {
  BHT03: "TrackingNumber",
  BHT04: "GeneratedAt",
  BHT05: "GeneratedAt",
  BHT06: "BhtTransactionTypeCode",
  BHT02: "BhtPurposeCode",
  GS04: "FunctionalGroupDate",
  GS_04: "FunctionalGroupDate",
  GS05: "FunctionalGroupTime",
  GS_05: "FunctionalGroupTime",
  ISA09: "InterchangeDate",
  ISA_09: "InterchangeDate",
  ISA10: "InterchangeTime",
  ISA_10: "InterchangeTime",
  ST02: "TransactionSetControlNumber",
  ST_02: "TransactionSetControlNumber",
  SE01: "SegmentCount",
  SE_01: "SegmentCount",
  SE02: "TransactionSetControlNumber",
  SE_02: "TransactionSetControlNumber",
  HL01: "HierarchicalId",
  HL_2000A_01: "HierarchicalId",
  HL02: "HierarchicalParentId",
  NM103_PR: "Payer.Name",
  NM108_PR: "Payer.IdentifierCode",
  NM109_PR: "Payer.PayerId",
  NM103_1P: "Requester.LastName",
  NM104_1P: "Requester.FirstName",
  NM105_1P: "Requester.MiddleName",
  NM108_1P: "Requester.IdentifierCode",
  NM109_1P: "Requester.Npi",
  NM102_1P: "Requester.EntityTypeQualifier",
  PER04_1P: "Requester.Phone",
  PER04_EP: "EventProvider.Phone",
  PER04_SJ: "ServiceProvider.Phone",
  PRV03_1P: "Requester.Taxonomy",
  REF01_1P: "SupplementalId.Qualifier",
  REF02_1P: "SupplementalId.Value",
  N301_1P: "Requester.Address.Line1",
  N302_1P: "Requester.Address.Line2",
  N401_1P: "Requester.Address.City",
  N402_1P: "Requester.Address.State",
  N403_1P: "Requester.Address.PostalCode",
  NM103_IL: "Subscriber.LastName",
  NM104_IL: "Subscriber.FirstName",
  NM105_IL: "Subscriber.MiddleName",
  NM109_IL: "Subscriber.MemberId",
  NM101_IL: "Subscriber.EntityId",
  NM102_IL: "Subscriber.EntityType",
  NM108_IL: "Subscriber.IdQualifier",
  INS01_IL: "Subscriber.IndividualRelationshipCode",
  INS02_IL: "Subscriber.RelationshipCode",
  N301_IL: "Subscriber.Address.Line1",
  N302_IL: "Subscriber.Address.Line2",
  N401_IL: "Subscriber.Address.City",
  N402_IL: "Subscriber.Address.State",
  N403_IL: "Subscriber.Address.PostalCode",
  NM103_QC: "Dependent.LastName",
  NM104_QC: "Dependent.FirstName",
  NM105_QC: "Dependent.MiddleName",
  DMG02: "Subscriber.BirthDate",
  DMG03: "Subscriber.Gender",
  DMG02_QC: "Dependent.BirthDate",
  DMG03_QC: "Dependent.Gender",
  DMG01: "Subscriber.DateFormat",
  UM01: "CertificationType",
  UM02: "CertificationAction",
  UM03: "AdmissionType",
  UM04: "PlaceOfService",
  UM05: "PlaceOfService",
  UM06: "LevelOfServiceCode",
  UM09: "HasAttachments",
  DTP03: "Services",
  HI01: "Diagnoses",
  HSD02: "LengthOfStayDays",
  TRN02: "TrackingNumber",
  REF02_BB: "OriginalAuthorizationNumber",
  MSG01: "Messages",
  SV101: "Service.ProcedureCode",
  SV102: "Service.ChargeAmount",
  SV104: "Service.Quantity",
  TRN02_SVC: "Service.ServiceTraceNumber",
  PWK01: "TrackingNumber",
  PWK06: "TrackingNumber",
  PWK01_SVC: "Service.ServiceTraceNumber",
  PWK06_SVC: "Service.ServiceTraceNumber",
  CRC01: "CertificationIndicator.Category",
  CRC02: "CertificationIndicator.Applies",
  CR103: "AmbulanceTransport.TransportCode",
  CR109: "AmbulanceTransport.Description",
  SV201: "Service.RevenueCode",
  SV202: "Service.ProcedureCode",
  SV301: "Service.DentalProcedureCode",
  TOO02: "CurrentToothCode",
};

/** Sample values for dynamic FHIR/model bindings when API/mock has no rendered value */
export const BINDING_SAMPLE_VALUES = {
  TrackingNumber: "AUTH123456",
  GeneratedAt: "20250722",
  BhtPurposeCode: "22",
  BhtTransactionTypeCode: "CH",
  ControlNumber: "000000001",
  TransactionSetControlNumber: "0001",
  SegmentCount: "18",
  HierarchicalId: "1",
  HierarchicalParentId: "",
  FunctionalGroupDate: "20250722",
  FunctionalGroupTime: "1430",
  InterchangeDate: "250722",
  InterchangeTime: "1430",
  "Envelope.SenderId": "SUBMITTER",
  "Envelope.ReceiverId": "RECEIVER",
  "Envelope.UsageIndicator": "P",
  "Envelope.TraceAssigningEntityId": "9876543210",
  "Payer.Name": "AETNA HEALTH",
  "Payer.PayerId": "60054",
  "Payer.IdentifierCode": "PI",
  "Requester.LastName": "VALLEY MEDICAL GROUP",
  "Requester.FirstName": "ROBERT",
  "Requester.MiddleName": "A",
  "Requester.OrganizationName": "VALLEY MEDICAL GROUP",
  "Requester.Npi": "1234567890",
  "Requester.Phone": "5551234567",
  "Requester.EntityTypeQualifier": "2",
  "Requester.IdentifierCode": "XX",
  "Requester.Taxonomy": "207Q00000X",
  "Requester.Address.Line1": "123 MAIN ST",
  "Requester.Address.Line2": "SUITE 200",
  "Requester.Address.City": "ANYTOWN",
  "Requester.Address.State": "PA",
  "Requester.Address.PostalCode": "19087",
  "Subscriber.LastName": "DOE",
  "Subscriber.FirstName": "JOHN",
  "Subscriber.MiddleName": "M",
  "Subscriber.MemberId": "MEM123456789",
  "Subscriber.BirthDate": "19850315",
  "Subscriber.Gender": "M",
  "Subscriber.RelationshipCode": "18",
  "Subscriber.IndividualRelationshipCode": "Y",
  "Subscriber.Address.Line1": "456 OAK AVE",
  "Subscriber.Address.Line2": "APT 2B",
  "Subscriber.Address.City": "PHILADELPHIA",
  "Subscriber.Address.State": "PA",
  "Subscriber.Address.PostalCode": "19103",
  "Dependent.BirthDate": "20100315",
  "Dependent.Gender": "F",
  "Dependent.LastName": "DOE",
  "Dependent.FirstName": "JANE",
  "Dependent.MiddleName": "L",
  "Dependent.RelationshipCode": "19",
  "Dependent.IndividualRelationshipCode": "N",
  "Dependent.Address.Line1": "456 OAK AVE",
  "Dependent.Address.City": "PHILADELPHIA",
  "Dependent.Address.State": "PA",
  "Dependent.Address.PostalCode": "19103",
  "SupplementalId.Qualifier": "0B",
  "SupplementalId.Value": "STATE-LIC-12345",
  "Service.ProcedureCode": "HC:99213",
  "Service.ChargeAmount": "150.00",
  "Service.Quantity": "1",
  "Service.ServiceDate": "20250722",
  "Service.RevenueCode": "0450",
  "Service.DentalProcedureCode": "AD:D0120",
  "Service.PlaceOfService": "11",
  "Service.Description": "Office visit",
  "Service.QuantityType": "UN",
  "Service.QuantityRequested": "1",
  "Service.MonetaryAmount.net": "150.00",
  "Service.MonetaryAmount.quantity": "1",
  "Service.MonetaryAmount.unitPrice": "150.00",
  "Service.OriginalAuthorizationNumber": "AUTH987654",
  "Service.AdminReferenceNumber": "ADMIN-REF-001",
  "Service.ServiceTraceNumber": "AUTH123456-S1",
  "Service.CertificationType": "HS",
  Services: "20250722-20250722",
  Service: "20250722",
  PrimaryDiagnosis: "M545",
  Diagnoses: "ABK:I219",
  CertificationType: "HS",
  CertificationAction: "I",
  PlaceOfService: "11:B:1",
  AdmissionType: "1",
  LevelOfServiceCode: "03",
  HasAttachments: "Y",
  OriginalAuthorizationNumber: "AUTH987654",
  AdminReferenceNumber: "ADMIN-REF-001",
  LengthOfStayDays: "7",
  "EventProvider.Phone": "5559876543",
  "EventProvider.LastName": "SMITH",
  "EventProvider.FirstName": "SARAH",
  "EventProvider.Npi": "9876543210",
  "ServiceProvider.Phone": "5559876543",
  "ServiceProvider.LastName": "JONES",
  "ServiceProvider.FirstName": "MICHAEL",
  "ServiceProvider.Npi": "1122334455",
  "ServiceProvider.Taxonomy": "207Q00000X",
  FacilityName: "MONTGOMERY HOSPITAL",
  FacilityIdentifier: "1234567890",
  FacilityIdentifierCode: "XX",
  "FacilityAddress.Line1": "475 MAIN STREET",
  "FacilityAddress.City": "ANYTOWN",
  "FacilityAddress.State": "PA",
  "FacilityAddress.PostalCode": "19087",
  Messages: "Prior authorization request for inpatient surgery",
  CurrentMessage: "Prior authorization request for inpatient surgery",
  CurrentServiceMessage: "Service line clinical note",
  CurrentToothCode: "14",
  "CertificationIndicator.Category": "09",
  "CertificationIndicator.Applies": "Y",
  "AmbulanceTransport.TransportCode": "DH",
  "AmbulanceTransport.DistanceQualifier": "MI",
  "AmbulanceTransport.TransportReason": "A",
  "AmbulanceTransport.PatientLocationCode": "Origin",
  "AmbulanceTransport.Description": "Emergency transport",
  "Frequency.QuantityQualifier": "VS",
  "Frequency.Quantity": "3",
  "Frequency.PeriodUnit": "WK",
  "Frequency.DurationQualifier": "DY",
  "Frequency.Duration": "30",
  "CertificationPeriod.CertificationStartDate": "20250701",
  CertificationPeriod: "20250701-20250731",
  "EventDates.AccidentDate": "20250701",
  "EventDates.OnsetDate": "20250615",
  "EventDates.AdmissionDate": "20250720",
  "EventDates.DischargeDate": "20250727",
  "Chiropractic.PatientConditionCode": "A",
  "Chiropractic.XRayAvailability": "Y",
  "OxygenTherapy.EquipmentTypeCode": "O",
  "OxygenTherapy.Quantity": "2.5",
  "TransportLocation.Name": "PICKUP LOCATION",
  "TransportLocation.Address1": "100 ER DR",
  "TransportLocation.City": "ANYTOWN",
  "TransportLocation.State": "PA",
  "TransportLocation.PostalCode": "19087",
  "OtherUmo.Name": "OTHER UMO",
  "OtherUmo.DenialReasonCode": "DEN001",
  "OtherUmo.DenialDate": "20250710",
};

/** Static TR3 defaults for entity qualifiers and fixed codes */
export const STATIC_ELEMENT_VALUES = {
  NM101_IL: { value: "IL", label: 'Static ("IL")' },
  NM102_IL: { value: "1", label: 'Static ("1")' },
  NM108_IL: { value: "MI", label: 'Static ("MI")' },
  NM101_PR: { value: "PR", label: 'Static ("PR")' },
  NM102_PR: { value: "2", label: 'Static ("2")' },
  NM101_1P: { value: "1P", label: 'Static ("1P")' },
  ST01: { value: "278", label: 'Static ("278")' },
  GS01: { value: "HI", label: 'Static ("HI")' },
  GS07: { value: "X", label: 'Static ("X")' },
  GS08: { value: "005010X217", label: 'Static ("005010X217")' },
  HL03_2000A: { value: "20", label: 'Static ("20")' },
  HL03_2000B: { value: "21", label: 'Static ("21")' },
  HL03_2000C: { value: "22", label: 'Static ("22")' },
  HL03_2000E: { value: "EV", label: 'Static ("EV")' },
  HL03_2000F: { value: "SS", label: 'Static ("SS")' },
  DMG01: { value: "D8", label: 'Static ("D8")' },
  BHT01: { value: "0007", label: 'Static ("0007")' },
  PWK01: { value: "OZ", label: 'Static ("OZ")' },
  PWK02: { value: "EL", label: 'Static ("EL")' },
  PWK05: { value: "AC", label: 'Static ("AC")' },
  PWK01_SVC: { value: "OZ", label: 'Static ("OZ")' },
  PWK02_SVC: { value: "EL", label: 'Static ("EL")' },
  PWK05_SVC: { value: "AC", label: 'Static ("AC")' },
  TOO01: { value: "JP", label: 'Static ("JP")' },
  CR601: { value: "1", label: 'Static ("1")' },
  CR603: { value: "RD8", label: 'Static ("RD8")' },
  CR609: { value: "I", label: 'Static ("I")' },
};

export function getFhirMapping(binding) {
  if (!binding) return null;
  return FHIR_MAPPINGS[binding] ?? null;
}
